function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 3; i += 1) {
    color += letters[Math.floor(Math.random() * 8) + 8];
  }
  return color;
}
export default getRandomColor;
